<template>
  <div>
    <div class="padding-top">
      <AppList
        :opts="opts"
        :formOpts="formOpts"
        :items="items"
        @formSuccess="onFormSuccess"
      />
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import api from '@/api'
import { Role } from '@/commons'
import auth from '@/auth'

export default {
  name: 'PageClients',

  data: () => ({
    items: [],
    opts: {
      titleKey: 'navs.clients',
      subtitleKey: 'misc.manageClients',
      searchName: 'title',
      createTextKey: 'actions.createClient',
      columns: [
        // {
        //   name: 'title',
        //   label: 'labels.client',
        //   type: 'edit',
        // },
        {
          name: 'switchClient',
          type: 'component',
          component: 'AppListSwitchClientTitle',
        },
        {
          name: 'address',
        },
        {
          name: 'reseller',
          formatter: (reseller) => {
            return (reseller && reseller.title) || '-'
          },
        },
        // Removed in favor or clicking on the client title to swtich to their dashboard.
        // {
        //   name: 'switchClient',
        //   type: 'component',
        //   component: 'AppListSwitchClient',
        // },
      ],
    },
    formOpts: {
      titleKey: 'navs.client',
      endpoint: 'clients',
      inputs: {
        title: {
          type: 'text',
          validation: {
            required,
          },
        },
        address: {
          type: 'text',
          validation: {
            required,
          },
        },
        // Removed in favor for feature handling (InputFeatures).
        // measurementCommentInAppEnabled: {
        //   type: 'switch'
        // },
        multiFactorAuthDisabled: {
          type: 'switch',
        },
        features: {
          type: 'component',
          component: 'InputFeatures',
        },
        // token: {
        //   title: 'API Key',
        //   type: 'component',
        //   component: 'input-client-token',
        // },
      },
      rows: [
        ['title'],
        ['address'],
        // ['measurementCommentInAppEnabled'],
        ['multiFactorAuthDisabled'],
        ['features'],
      ],
    },
  }),

  mounted() {
    // TODO: their must be a better way than this.
    if (this.$auth.hasRole(Role.Superadmin)) {
      this.formOpts.inputs.reseller = {
        title: 'Reseller',
        type: 'component',
        component: 'InputReseller',
      }
      this.formOpts.rows.push(['reseller'])
    }

    this.fetchData()
  },

  methods: {
    async fetchData() {
      const [err, clients] = await api.get('clients').send()
      if (err) return
      this.items = clients
    },

    onFormSuccess(event) {
      const { isCreate, response } = event

      if (isCreate) {
        auth.switchClient(response._id, () => {
          this.$router.push({ name: 'entities' })
        })
      } else {
        this.fetchData()
      }
    },
  },
}
</script>
